
import { translateServiceInstance } from 'dp-formio';
import { Utils } from 'formiojs';

const ar = 'ar';
export enum StatusConfig {
    UnComplete, Complete
}
export class ProcessConfig {
    _id: string;
    key: string;
    categoryLevelCount: number;
    answerMaxScore: number;
    categoryAssessment: string[]; //list of 'keys'
    displayNumberBy: 'order' | 'pattern';
    categoryNumberPattern: string;
    questionNumberPattern: string;
    scoreConditions: ScoreConditionsConfig[];

    evaluationItems: EvaluationItemsConfig[];
    evaluationLevels: EvaluationLevelsConfig[];
    hasEvaluationItems: boolean;
}

export class ScoreConditionsConfig {
    lessThan: number;
    greaterThan: number;
    messageAr: string;
    messageEn: string;

    get message() {
        return translateServiceInstance?.currentLang == ar ? this.messageAr : this.messageEn;
    }
}
export class CategoryConfig {
    _id: string;
    key: string;
    originKey: string;
    nameAr: string;
    nameEn: string;
    descriptionAr: string;
    descriptionEn: string;
    order: number;
    color: string;
    levelNumber: number;
    parentCategory: string; //list of 'keys'
    questionsAssessment: string[]; //list of 'keys'
    averageToPass: number;
    weight: number;
    errorAr: string;
    errorEn: string;
    optionalInputs: OptionalInputConfig[];
    isDescriptionStandardRequired: boolean;
    descriptionStandardResult: string;

    //#region pledge
    pledgeNameAr: string;
    pledgeNameEn: string;
    pledgeTooltipAr: string;
    pledgeTooltipEn: string;
    pledgeIsRequired: boolean;
    pledgeValue: boolean;

    
    get pledgeName() {
        // console.log('pledgeName called',this)
        return translateServiceInstance?.currentLang == ar ? this.pledgeNameAr : this.pledgeNameEn;
    }
    get pledgeTooltip() {
        return translateServiceInstance?.currentLang == ar ? this.pledgeTooltipAr : this.pledgeTooltipEn;
    }
    get hasPledgeAndAcknowledgment() { return !!this.pledgeName; }
    //#endregion
    //#region attachments
    attachmentsTooltipAr: string;
    attachmentsTooltipEn: string;
    attachments: AttachmentsConfig[];
    get attachmentsTooltip() {
        console.log('attachmentsTooltip',this)
        return translateServiceInstance?.currentLang == ar ? this.attachmentsTooltipAr : this.attachmentsTooltipEn;
    }
    get attachmentsName() {
        console.log('attachmentsName',this)
        return translateServiceInstance?.currentLang == ar ? this.attachmentsTooltipAr : this.attachmentsTooltipEn;
    }
    get attachmentsValid() {
        // if (!this.attachmentIsRequired) return true;
        // return !!this.data?.length;
        //this.attachments.every(q => q.valid);
        // console.log('this.attachments.every(q => q.valid)',this.attachments.every(q =>  function(q){
        //     console.log('q.attachmentIsRequired',q.attachmentIsRequired); 
        //     if (!q.attachmentIsRequired) return true;
        //     console.log('q.data?.length',q.data?.length); 
        //     return q.data?.length>0;}))
        if(!Array.isArray(this.attachments)){
            return true;
        }
            // console.log('this.attachments.every(q => q.valid)',this.attachments.every(q=>{
            //     // console.log('check attachment');
            //     if (!q.attachmentIsRequired) return true
            //     return q.data?.length>0;
            // }));
            // console.log('this.attachments.every(q => q.valid)',this.attachments.every(attachmentIsValid));
        return this.attachments.every(q=>{
            if (!q.attachmentIsRequired) return true
            return q.data?.length>0;
        });
      
    }
    
    get hasAttachments() { return this.attachments?.length; }
    //#endregion

    get name() {
        return translateServiceInstance?.currentLang == ar ? this.nameAr : this.nameEn;
    }
    get description() {
        return translateServiceInstance?.currentLang == ar ? this.descriptionAr : this.descriptionEn;
    }
    get error() {
        return translateServiceInstance?.currentLang == ar ? this.errorAr : this.errorEn;
    }

    get hasError() {
        // if (!this.hasOptionalInputs || !this.isScoreValid) return true;
        if (!this.isScoreValid) return true;
        else return false;
    }
    get isScoreValid() {
        return (this.scoreResult ?? 0) >= (this.averageToPass || 0);
    }

    get hasOptionalInputs() {
        if(this.originKey=="test")
            return true;
        var tempOptionalInputs = this.optionalInputs.filter(q=>!q.nameAr.includes("الرأي المستقل"))
        // console.log('from here',tempOptionalInputs);
        return tempOptionalInputs?.every(q => q.results?.length) || false;
    }
    get displayOrder() {
        if (!this.processConfigObject) return ``;
        if (this.processConfigObject.displayNumberBy == 'order')
            return `${this.order}`;
        else {
            return this.processConfigObject.categoryNumberPattern.replace('{{i}}', `${this.order}`);
        }
    }

    get calculatedScore() {
        this.sumScore = 0;
        let sumQuestions = 0;
        // calc from questions or sub categorires
        if (this.questionsAssessmentObject?.length) {
            this.questionsAssessmentObject.filter(q => !q.notApply && q.status == StatusConfig.Complete).forEach(q => {
                if (q.hasEvaluationItems) {
                    const evaluationsAnswerd = q.evaluationItems.filter(q => !!q.score);
                    this.sumScore += evaluationsAnswerd.reduce((a, b) => a + +b.score, 0) / evaluationsAnswerd.length;
                }
                else this.sumScore += (+q.value || 0) * (q.weight || 1);
                sumQuestions += q.weight || 1;
            });
        }
        else if (this.subCategoriresObject?.length) {
            this.subCategoriresObject.filter(q => q.calculatedScore).forEach(q => {
                this.sumScore += +q.calculatedScore * (q.weight || 1);
                sumQuestions += q.weight || 1;
            });
        }
        if (!sumQuestions) return 0;
        return this.sumScore / sumQuestions;
    }
    get calculatedSavedScore() {
        if (!this.numberOfApplicable) return 0;
        return this.totalEvaluationCriteria / this.numberOfApplicable;
    }

    get evaluationScoreMessage() {
        if (!this.processConfigObject) return ``;
        // let score = this.calculatedScore;
        let score = 0;
        if (!score && this.totalEvaluationCriteria) score = this.totalEvaluationCriteria / this.numberOfApplicable;
        return this.processConfigObject.scoreConditions.find(q =>
            (q.lessThan && !q.greaterThan && score <= q.lessThan) ||
            (!q.lessThan && q.greaterThan && score >= q.greaterThan) ||
            (q.lessThan && q.greaterThan && score <= q.lessThan && score > q.greaterThan)
        )?.message || ``;
    }

    processConfigObject: ProcessConfig; // calculated
    parentCategoryObject: CategoryConfig; // calculated
    subCategoriresObject: CategoryConfig[]; // calculated
    subCategoriresObjectForSelect: CategoryConfig[]; // calculated
    questionsAssessmentObject: QuestionConfig[]; // calculated

    totalEvaluationCriteria: number = 0;
    numberOfApplicable: number = 0;

    scoreResult: number = 0;
    percentage: number = 0;
    score: number = 0;
    sumScore: number = 0;
    get questionAnsweredCount() {
        if (this.questionsAssessmentObject?.length)
            return this.questionsAssessmentObject.filter(q => !q.notApply && q.status == StatusConfig.Complete).length;
        else return 0;
    }
}

export class OptionalInputConfig {
    nameAr: string;
    nameEn: string;

    get name() {
        return translateServiceInstance?.currentLang == ar ? this.nameAr : this.nameEn;
    }

    results: Array<{ value: string }> = [];
    value?:any
}

export class QuestionConfig {
    _id: string;
    key: string;
    nameAr: string;
    nameEn: string;
    tooltipAr: string;
    tooltipEn: string;
    order: number;
    isRequired: boolean;
    averageToPass: number;
    weight: number;
    errorAr: string;
    errorEn: string;
    answerTooltip: AnswerConfig[];
    parentCategoryObject: CategoryConfig; // calculated

    hasEvaluationItems: boolean;
    evaluationItems: EvaluationItemsConfig[];
    evaluationLevels: EvaluationLevelsConfig[];

    get name() {
        return translateServiceInstance?.currentLang == ar ? this.nameAr : this.nameEn;
    }
    get tooltip() {
        return translateServiceInstance?.currentLang == ar ? this.tooltipAr : this.tooltipEn;
    }
    get error() {
        return translateServiceInstance?.currentLang == ar ? this.errorAr : this.errorEn;
    }

    get hasError() {
        if (this.hasEvaluationItems) {
            const evaluationsAnswerd = this.evaluationItems.filter(q => !!q.score);
            this.value = (evaluationsAnswerd.reduce((a, b) => a + +b.score * (b.weight || 1), 0) / evaluationsAnswerd.length) + '';

            if (this.evaluationItems.some(q => q.hasError)) return true;
            else return (+this.value || 0) < this.averageToPass;
        }
        else return (+this.value || 0) * (this.weight || 1) < this.averageToPass;
    }
    get displayOrder() {
        if (!this.parentCategoryObject.processConfigObject) return ``;
        if (this.parentCategoryObject.processConfigObject.displayNumberBy == 'order')
            return `${this.order}`;
        else {
            return this.parentCategoryObject.processConfigObject.questionNumberPattern.replace('{{i}}', `${this.order}`);
        }
    }
    //#region notes
    notesNameAr: string;
    notesNameEn: string;
    notesTooltipAr: string;
    notesTooltipEn: string;
    notesIsRequired: boolean;
    get notesName() {
        return translateServiceInstance?.currentLang == ar ? this.notesNameAr : this.notesNameEn;
    }
    get notesTooltip() {
        return translateServiceInstance?.currentLang == ar ? this.notesTooltipAr : this.notesTooltipEn;
    }
    //#endregion

    //#region link
    linkNameAr: string;
    linkNameEn: string;
    linkTooltipAr: string;
    linkTooltipEn: string;
    linkIsRequired: boolean;
    get linkName() {
        return translateServiceInstance?.currentLang == ar ? this.linkNameAr : this.linkNameEn;
    }
    get linkTooltip() {
        return translateServiceInstance?.currentLang == ar ? this.linkTooltipAr : this.linkTooltipEn;
    }
    //#endregion

    //#region pledge
    pledgeNameAr: string;
    pledgeNameEn: string;
    pledgeTooltipAr: string;
    pledgeTooltipEn: string;
    pledgeIsRequired: boolean;
    get pledgeName() {
        return translateServiceInstance?.currentLang == ar ? this.pledgeNameAr : this.pledgeNameEn;
    }
    get pledgeTooltip() {
        return translateServiceInstance?.currentLang == ar ? this.pledgeTooltipAr : this.pledgeTooltipEn;
    }
    //#endregion

    //#region attachments
    attachmentsTooltipAr: string;
    attachmentsTooltipEn: string;
    attachments: AttachmentsConfig[];
    get attachmentsTooltip() {
        console.log('attachmentsTooltip01',this)
        return translateServiceInstance?.currentLang == ar ? this.attachmentsTooltipAr : this.attachmentsTooltipEn;
    }
    get attachmentsValid() {
        return this.attachments.every(q => q.valid);
    }
    //#endregion

    get hasNotes() { return !!this.notesName; }
    get hasLink() { return !!this.linkName; }
    get hasPledgeAndAcknowledgment() { return !!this.pledgeName; }
    get hasAttachments() { return this.attachments.length; }

    status: StatusConfig = StatusConfig.UnComplete;
    notApply: boolean = false;
    value: string;
    notesValue: string;
    linkValue: string;
    pledgeValue: boolean;
}

export class AnswerConfig {
    score: number;
    tooltipAr: string;
    tooltipEn: string;

    get tooltip() {
        return translateServiceInstance?.currentLang == ar ? this.tooltipAr : this.tooltipEn;
    }
}

export class AttachmentsConfig {
    attachmentIsRequired: boolean;
    attachmentTooltipAr: string;
    attachmentTooltipEn: string;
    attachmentNameAr: string;
    attachmentNameEn: string;
    get attachmentsTooltip() {
        return translateServiceInstance?.currentLang == ar ? this.attachmentTooltipAr : this.attachmentTooltipEn;
    }
    get name() {
        return translateServiceInstance?.currentLang == ar ? this.attachmentNameAr : this.attachmentNameEn;
    }
    get tooltip() {
        return translateServiceInstance?.currentLang == ar ? this.attachmentTooltipAr : this.attachmentTooltipEn;
    }

    data: any[] = [];
    get valid() {
        if (!this.attachmentIsRequired) return true;
        return !!this.data?.length;
    }
   
}

export class EvaluationItemsConfig {
    nameAr: string;
    nameEn: string;
    tooltipAr: string;
    tooltipEn: string;
    order: number;
    weight: number;
    averageToPass: number;
    errorAr: string;
    errorEn: string;

    score: number | string;

    get name() {
        return translateServiceInstance?.currentLang == ar ? this.nameAr : this.nameEn;
    }
    get tooltip() {
        return translateServiceInstance?.currentLang == ar ? this.tooltipAr : this.tooltipEn;
    }
    get error() {
        return translateServiceInstance?.currentLang == ar ? this.errorAr : this.errorEn;
    }
    get hasError() {
        return (+this.score || 0) * (this.weight || 1) < this.averageToPass;
    }
}

export class EvaluationLevelsConfig {
    arabicLabel: string;
    englishLabel: string;
    score: number;
    _id: string;

    get label() {
        return translateServiceInstance?.currentLang == ar ? this.arabicLabel : this.englishLabel;
    }

    get id() {
        if (!this._id) this._id = `${new Date().getTime()}`;
        return this._id;
    }
}